import Dashboard from './src/pages/Dashboard';
import MenuCardSaga from './MenuCardSaga';
import MenuUser from './MenuUser';
import MenuHeroSaga from './MenuHeroSaga';
import MenuFamiliarSaga from './MenuFamiliarSaga';
import MenuItemSaga from './MenuItemSaga';
import MenuShopSaga from './MenuShopSaga';
import MenuEventSaga from './MenuEventSaga';

const Menu = [
    {
        id: 'dashboard',
        name: 'Dashboard',
        icon: 'icon-speedometer',
        path: 'dashboard',
        component: Dashboard,
        isShown: 1,
    },
    {
        id: 'eventSaga',
        name: 'Event Saga',
        icon: 'icon-list',
        isShown: 1,
        submenu: [...MenuEventSaga],
    },
    {
        id: 'user',
        name: 'User',
        icon: 'icon-people',
        isShown: 1,
        submenu: [...MenuUser],
    },
    {
        id: 'cardSaga',
        name: 'Card Saga',
        icon: 'icon-list',
        isShown: 1,
        submenu: [...MenuCardSaga],
    },
    {
        id: 'heroSaga',
        name: 'Hero Saga',
        icon: 'icon-list',
        isShown: 1,
        submenu: [...MenuHeroSaga],
    },
    {
        id: 'familiarSaga',
        name: 'Familiar Saga',
        icon: 'icon-list',
        isShown: 1,
        submenu: [...MenuFamiliarSaga],
    },
    {
        id: 'itemSaga',
        name: 'Item Saga',
        icon: 'icon-list',
        isShown: 1,
        submenu: [...MenuItemSaga],
    },
    {
        id: 'shopSaga',
        name: 'Shop Saga',
        icon: 'icon-list',
        isShown: 1,
        submenu: [...MenuShopSaga],
    },
    {
        id: 'logout',
        name: 'Logout',
        icon: 'icon-logout',
        path: '#',
        isShown: 1,
    },
];

export default Menu;
